import { showImpMenu, hideImpMenu } from '../alerts.js';

// User management impersonation functionality
function setupImpersonation(userCardContainer) {
  if (userCardContainer) {
    userCardContainer.addEventListener('click', async function (event) {
      const targetButton = event.target.closest('.btn__userEdit');
      if (targetButton) {
        const userID = targetButton.getAttribute('userID');
        //httpx.softDelete(userID);
      }

      const impersonateLink = event.target.closest('.card__impersonate');
      if (
        impersonateLink &&
        !impersonateLink.classList.contains('card__impersonate--disabled')
      ) {
        event.preventDefault(); // Prevent the default link behavior
        const userID = impersonateLink.getAttribute('userID');
        const currentUser = impersonateLink.getAttribute('currentUser');
        try {
          const response = await fetch(`/api/v1/users/impersonate/${userID}`, {
            method: 'GET',
          });
          const data = await response.json();
          if (data.status === 'success') {
            localStorage.setItem(
              'impMenuShown',
              JSON.stringify([data.data.user.userName, currentUser]),
            );
            window.location.href = '/';
          } else {
            console.error('Impersonation failed');
          }
        } catch (error) {
          console.error('Error during impersonation', error);
        }
      }
    });
  }
}

// Setup stop impersonation button
document.addEventListener('DOMContentLoaded', function () {
  const stopImpersonateBtn = document.querySelector('.btn-stop-impersonate');
  if (stopImpersonateBtn)
    stopImpersonateBtn.addEventListener('click', async () => {
      const oriUser = JSON.parse(localStorage.getItem('impMenuShown'))[1];
      try {
        const response = await fetch(
          `/api/v1/users/stopImpersonation/${oriUser}`,
          {
            method: 'GET',
          },
        );
        const data = await response.json();
        if (data.status === 'success') {
          hideImpMenu();
          window.location.href = '/users';
        } else {
          console.error('Stopping impersonation failed');
        }
      } catch (error) {
        console.error('Error during stopping impersonation', error);
      }
    });
});

// Show impersonation menu if active
if (localStorage.getItem('impMenuShown')) {
  const name = JSON.parse(localStorage.getItem('impMenuShown'))[0];
  showImpMenu(name);
}

export { setupImpersonation };
